<!-- 个人中心 -->
<template>
  <div style="background-color: #F6F6F6;padding-top: 80px;">
    <div class="personalCore-box">
      <div class="personalCore-left">
        <div class="search-int" style="margin-bottom: 40px;">
          <input type="text" v-model="keywords" placeholder="搜索职位/公司/内容关键词">
          <div @click="search()">搜索</div>
        </div>
        <div class="EnterpriseIndex-h1">
          <div class="EnterpriseIndex-change" @click="change(0)" :style="{'background-color': tablebar == 0 ? '#5C79F5' : '#fff' }">
            <div :style="{'color': tablebar == 0 ? '#fff' : '' }">我收到的</div>
            <p :style="{'background-color': tablebar == 0 ? '#fff' : ''}">{{detailCount.resumeCount}}</p>
          </div>
          <div class="EnterpriseIndex-change" @click="change(1)" :style="{'background-color': tablebar == 1 ? '#5C79F5' : '#fff' }">
            <div :style="{'color': tablebar == 1 ? '#fff' : '' }">我的收藏</div>
            <p :style="{'background-color': tablebar == 1 ? '#fff' : ''}">{{detailCount.collectCount}}</p>
          </div>
          <div class="EnterpriseIndex-change" @click="change(2)" :style="{'background-color': tablebar == 2 ? '#5C79F5' : '#fff' }">
            <div :style="{'color': tablebar == 2 ? '#fff' : '' }">我的下载</div>
            <p :style="{'background-color': tablebar == 2 ? '#fff' : ''}">{{detailCount.downloadCount}}</p>
          </div>
          <div class="EnterpriseIndex-change" @click="change(3)" :style="{'background-color': tablebar == 3 ? '#5C79F5' : '#fff' }">
            <div :style="{'color': tablebar == 3 ? '#fff' : '' }">职位列表</div>
            <p :style="{'background-color': tablebar == 3 ? '#fff' : ''}">{{detailCount.jobCount}}</p>
          </div>
        </div>
        <div class="personalCore-left-list" v-if="tablebar!=3&&resumeList!==undefined&&resumeList.length > 0" style="float: left;width: 100%;">
          <div class="personalCore-joblist" v-for="(item,index) in resumeList" :key="index" @click="addResume(item.id)">
            <div class="personalCore-jobboxs">
              <img class="personalCore-jobboxs-img" v-if="item.logo!==undefined" :src="item.logo" />
              <img class="personalCore-jobboxs-img" src="../../assets/boyLogo.png" v-if="item.logo==undefined&&item.sex==0" alt="">
              <img class="personalCore-jobboxs-img" src="../../assets/girlLogo.png" v-if="item.logo==undefined&&item.sex==1" alt="">
              <div class="personalCore-jobboxs-box">
                <div class="personalCore-jobboxs-box-name" style="overflow: hidden;">
                  <div style="float: left;">{{item.name}}</div>
                </div>
                <div class="personalCore-jobboxs-box-tabel">
                  <div>{{item.age}}</div>
                  <div>{{item.edu}}</div>
                  <div>{{item.work}}年工作经验</div>
                  <!-- <div>{{item.cityName}}</div>s -->
                </div>
                <div class="personalCore-jobboxs-box-job">
                  求职期望：
                  <span>{{item.cityName}}</span>
                  <span v-if="item.cityName!==undefined">|</span>
                  <span>{{item.jobName}}</span>
                  <span v-if="item.jobName!==undefined">|</span>
<!--                  <span>{{item.salary}}-{{item.salaryEnd}}/月</span>-->
                  <span>{{item.salaryName}}</span>
                </div>
              </div>
              <div class="personalCore-jobboxs-money">
                <div class="personalCore-jobboxs-money-btn" style="margin-right: 16px;" @click="addResume(item.id)" v-if="tablebar!==3">
                  <img src="../../assets/download.png" alt="">
                  <div>下载</div>
                </div>
                <div class="personalCore-jobboxs-money-btn" style="background-color: #587CF7;" @click.stop="preserves(item.id)" v-if="tablebar!==3&&item.collectTime==undefined">
                  <img src="../../assets/collect.png" alt="">
                  <div style="color: #fff;">收藏</div>
                </div>
                <div class="personalCore-jobboxs-money-btn" style="background-color: #587CF7;width: 108px;" @click.stop="preserve(item.id)" v-if="tablebar!==3&&item.collectTime!==undefined">
                  <img src="../../assets/iscollect.png" alt="">
                  <div style="color: #fff;">取消收藏</div>
                </div>
                <div v-if="item.collectTime!==undefined" style="font-size: 12px;color: #757575;text-align: right;">上传时间：{{item.collectTime}}</div>
              </div>
            </div>
          </div>
          <el-pagination :current-page="pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background layout="prev, pager, next" :total="totalNum" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
        <div class="personalCore-left-list" v-else-if="tablebar==3&&resumeList!==undefined&&resumeList.length > 0" style="float: left;width: 100%;">
          <div class="personalCore-joblists" v-for="(item,index) in resumeList" :key="index" style="position: relative;">
            <div class="personalCore-jobboxs" style="height: 151px;">
              <div class="personalCore-jobboxs-box" @click="editJobs(item.id, item.status)">
                <div class="personalCore-jobboxs-box-names">{{item.name}}</div>
                <div class="personalCore-jobboxs-box-titles">
<!--                  <div>{{item.salary}}-{{item.salaryEnd}}元/月</div>-->
                  <div>{{item.salaryName}}</div>
                  <div>{{item.eduName}}</div>
                  <div>{{item.workName}}</div>
                </div>
              </div>
              <div class="personalCore-jobboxs-money" style="margin-top:38px;">
                <div class="personalCore-jobboxs-money-btn" style="margin-right: 16px;" v-if="tablebar==3" @click.stop="editJob(item.id)">
                  <img src="../../assets/edit-icon.png" alt="">
                  <div>编辑</div>
                </div>
                <div class="personalCore-jobboxs-money-btn" style="background-color: #587CF7;margin-right: 16px;" v-if="tablebar==3" @click.stop="editJobs(item.id, item.status)">
                  <img src="../../assets/examine.png" alt="">
                  <div style="color: #fff;">查看</div>
                </div>
                <el-dropdown class="personalCore-jobboxs-money-btn" @command="handleNature">
                  <span class="el-dropdown-link" style="margin-left: 0px;">
                    更多<img src="../../assets/wrap.png" alt="">
                  </span>
                  <el-dropdown-menu class="project-dropdown" style="width: 86px;text-align: center;padding: 0;height: 72px;" slot="dropdown">
                    <el-dropdown-item v-if="item.status==3" :command="beforeHandleCommand(item.status, item.id, 1)">上架</el-dropdown-item>
                    <el-dropdown-item v-if="item.status==1" :command="beforeHandleCommand(item.status, item.id, 1)">下架</el-dropdown-item>
                    <el-dropdown-item :command="beforeHandleCommand(item.status, item.id, 2)">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="personalCore-jobboxs-box-résumé" @click="editJobs(item.id, item.status)">
                <div>{{item.resumeCount}}</div>
                <div>收到简历</div>
              </div>
              <div class="personalCore-jobboxs-bottom" @click="editJobs(item.id, item.status)">
                <div class="personalCore-jobboxs-bottom-titles">
                  <div v-for="(items, indexs) in item.tagList" :key="indexs" v-if="indexs<5">{{items.title}}<span v-if="indexs<4">|</span></div>
                </div>
                <div class="personalCore-jobboxs-bottom-time" v-if="item.updateTime!==undefined">更新时间：{{item.updateTime}}</div>
                <div class="personalCore-jobboxs-bottom-btn" v-if="item.status==3">已下架</div>
                <div class="personalCore-jobboxs-bottom-btn" style="color:#FF6400;" v-if="item.status==1">已上架</div>
              </div>
            </div>
          </div>
          <el-pagination :current-page="pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" background layout="prev, pager, next" :total="totalNum" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
        <div v-else style="text-align: center;margin-bottom: 40px;">
          <img style="margin-top: 100px;margin-bottom: 10px;" src="../../assets/searchEmpty.png" alt="">
          <div style="font-size: 14px;color: #9C9C9C;">暂无简历</div>
        </div>
      </div>
      <!-- 个人信息 -->
      <div class="personalCore-right">
        <div class="personalCores-right-info">
          <img :src="userInfo.userPhoto" />
          <div class="personalCores-right-info-divs">
            <div class="personalCores-right-info-div-name">{{userInfo.companyName}}</div>
            <div class="personalCores-right-info-div-vip" v-if="userInfo.isCompanyVip==true">企业会员</div>
          </div>
        </div>
        <div class="personalCore-right-box">
          <div class="personalCore-right-boxs" style="margin-left: 32px;" @click="go()">
            <img src="../../assets/Enterprise-icon1.png" />
            <div>职位列表</div>
          </div>
          <div class="personalCore-right-boxs" style="margin-left: 24px;" @click="curriculumVitae()">
            <img src="../../assets/Enterprise-icon2.png" />
            <div>简历管理</div>
          </div>
          <div class="personalCore-right-boxs" style="margin-left: 32px;" @click="goss()">
            <img src="../../assets/Enterprise-icon4.png" />
            <div>企业信息</div>
          </div>
          <div class="personalCore-right-boxs" style="margin-left: 24px;" @click="postRelease()">
            <img src="../../assets/Enterprise-icon3.png" />
            <div>发布职位</div>
          </div>
        </div>
      </div>
      <!-- 个人信息 -->
    </div>
  </div>
</template>

<script>
import request from '../../util/request'

export default {
  data () {
    return {
      resumeList: [],
      jobName: '',
      userInfo: {},
      totalNum: 0,
      keywords: '',
      type: 1,
      pageSize: 10,
      pageNum: 1,
      tablebar: 0,
      detailCount: {}
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getList()
      this.getData()
    })
  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.userInfo = res.data.data.userInfo
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getList () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/resumeCollectList`,
        data: JSON.stringify({
          type: that.type,
          pageSize: that.pageSize,
          pageNum: that.pageNum
        })
      }).then(
        (res) => {
          that.resumeList = res.data.data.list
          that.totalNum = res.data.data.totalNum
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/companyDetailCount`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.detailCount = res.data.data.detailCount
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    getJob () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/jobList`,
        data: JSON.stringify({
          pageSize: that.pageSize,
          pageNum: that.pageNum
        })
      }).then(
        (res) => {
          that.resumeList = res.data.data.jobInfoList
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 上下架
    operateJob (e, id) {
      var that = this
      var operation = e
      if (operation === 3) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user/changeJob`,
          data: JSON.stringify({
            id: id,
            operation: 1
          })
        }).then(
          (res) => {
            that.$message.success('上架成功')
            that.getJob()
          },
          (err) => {
            that.$message.error(err)
          }
        )
      } else {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user/changeJob`,
          data: JSON.stringify({
            id: id,
            operation: 2
          })
        }).then(
          (res) => {
            that.$message.success('下架成功')
            that.getJob()
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }
    },
    // 取消收藏
    preserve (id) {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/job/addCollection`,
        data: JSON.stringify({
          id: id,
          type: 2,
          operation: 2
        })
      }).then(
        (res) => {
          that.$message.success('取消收藏成功')
          that.getList()
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    // 收藏
    preserves (id) {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/job/addCollection`,
        data: JSON.stringify({
          id: id,
          type: 2,
          operation: 1
        })
      }).then(
        (res) => {
          that.$message.success('收藏成功')
          that.getList()
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    addResume (id) {
      this.$router.push({
        path: '/resumeDetail',
        query: {
          id: id
        }
      })
    },
    change (e) {
      var that = this
      that.tablebar = e
      that.pageNum = 1
      if (e === 0) {
        that.type = 1
        that.getList()
      } else if (e === 1) {
        that.type = 2
        that.getList()
      } else if (e === 2) {
        that.type = 3
        that.getList()
      } else {
        that.getJob()
      }
    },
    // 分页
    search () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/ web/user/resumeList`,
        data: JSON.stringify({
          jobName: that.jobName
        })
      }).then(
        (res) => {
          that.resumeList = res.data.data.resumeList
          that.totalNum = res.data.data.resumeList
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    enterpriseDetails (id) {
      this.$router.push({
        path: '/enterpriseDetails',
        query: {
          id: id
        }
      })
    },
    // 删除岗位
    deleteJob (id) {
      var that = this
      that.$confirm('此操作将永久删除该岗位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/web/user/delJob`,
          data: JSON.stringify({
            id: id
          })
        }).then(
          (res) => {
            that.$message.success('删除成功')
            that.getJob()
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }).catch(() => {})
    },
    beforeHandleCommand (status, id, index) {
      return {
        id: id,
        status: status,
        index: index
      }
    },
    handleNature (command) {
      var that = this
      if (command.index === 1) {
        that.operateJob(command.status, command.id)
      } else {
        that.deleteJob(command.id)
      }
    },
    go () {
      this.$router.push({ path: '/jobLists' })
    },
    postRelease () {
      this.$router.push({ path: '/releaseJob' })
    },
    goss () {
      this.$router.push({ path: '/enterpriseInformation' })
    },
    curriculumVitae () {
      this.$router.push({ path: '/curriculumVitae' })
    },
    handleSizeChange (val) {
      this.pageNum = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getList()
    },
    editJob (e) {
      this.$router.push({
        path: '/releaseJob',
        query: {
          id: e
        }
      })
    },
    editJobs (e, operation) {
      this.$router.push({
        path: '/jobDetails',
        query: {
          id: e,
          isexamine: true,
          operation: operation
        }
      })
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
.personalCore-box{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 27px;
}
.personalCore-left{
  width: 860px;
  float: left;
  margin-right: 20px;
}
.personalCore-left-top{
  width: 860px;
  height: 57px;
  background-color: #fff;
  margin-bottom: 17px;
  overflow: hidden;
}
.personalCore-left-h1{
  float: left;
  line-height: 57px;
  font-size: 18px;
  font-weight: 550;
  margin-left: 25px;
}
.personalCore-left-search{
  float: right;
  overflow: hidden;
  height: 34px;
  margin-top: 14px;
  margin-right: 22px;
  line-height: 34px;
}
.personalCore-left-search input{
  float: left;
  height: 34px;
  line-height: 34px;
  border: none;
  background-color: #EFEFEF;
  border-radius: 17px;
  padding-left: 1rem;
  padding-right: 50px;
  outline: none;
}
.personalCore-left-search div{
  float: left;
  background-color: #587CF7;
  color: #fff;
  height: 26px;
  line-height: 26px;
  margin-top: 4px;
  font-size: 13px;
  width: 45px;
  text-align: center;
  border-radius: 15px;
  margin-left: -50px;
  cursor:pointer;
}
.personalCore-left-menus{
  float: right;
  margin-top: 14px;
  margin-right: 22px;
  background-color: #EFEFEF;
  width: 268px;
  height: 34px;
  line-height: 34px;
  border-radius: 8px;
}
.personalCore-left-list{
  float: left;
}
.personalCore-joblists{
  width: 860px;
  margin-right: 9px;
  margin-bottom: 16px;
}
.personalCore-jobboxs{
  width: 860px;
  height: 133px;
  background-color: #ffff;
  border-radius: 5px;
  cursor: pointer;
}
.personalCore-jobboxs-img{
  width: 66px;
  height: 66px;
  border-radius: 50%;
  float: left;
  margin-left: 20px;
  margin-top: 34px;
}
.personalCore-jobboxs-box{
  float: left;
  margin-left: 24px;
}
.personalCore-jobboxs-box-name{
  margin-top: 20px;
  margin-bottom: 12px;
  font-size: 18px;
  overflow: hidden;
}
.personalCore-jobboxs-box-tabel{
  overflow: hidden;
  margin-bottom: 16px;
}
.personalCore-jobboxs-box-tabel div{
  float: left;
  padding: 0 14px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  border: 1px solid #0091FF;
  border-radius: 4px;
  color: #288FFF;
  margin-right: 20px;
}
.personalCore-jobboxs-box-job{
  color: #757575;
  font-size: 14px;
}
.personalCore-jobboxs-money{
  float: right;
  margin-top: 46px;
  margin-right: 20px;
  font-size: 18px;
  color: #FF6400;
}
.personalCore-jobboxs-money-btn{
  float: left;
  width: 84px;
  height: 40px;
  overflow: hidden;
  border: 1px solid #587CF7;
  line-height: 40px;
  border-radius: 5px;
  margin-bottom: 8px;
}
.personalCore-jobboxs-money-btn img{
  float: left;
  width: 20px;
  height: 20px;
  margin-left: 16px;
  margin-top: 10px;
  margin-right: 4px;
}
.personalCore-jobboxs-money-btn div{
  color: #587CF7;
  font-size: 14px;
}
.personalCore-right{
  width: 307px;
  float: left;
  height: 407px;
  background-color: #fff;
  border-radius: 10px;
}
.personalCores-right-info{
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}
.personalCores-right-info img{
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 37.5px;
}
.personalCores-right-info-divs{
  float: left;
  margin-top: 36px;
  width: 60%;
}
.personalCores-right-info-div-name{
  font-size: 18px;
  margin-bottom: 8px;
}
.personalCores-right-info-div-vip{
  font-size: 12px;
  color: #E7BD7F;
  width: 71px;
  height: 19px;
  line-height: 19px;
  background-color: #373333;
  text-align: center;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}
.personalCore-right-box{
  width: 100%;
}
.personalCore-right-boxs{
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
  margin-left: 44px;
  margin-top: 24px;
  cursor: pointer;
}
.personalCore-right-boxs img{
  width: 100%;
  height: 100%;
}
.personalCore-right-boxs div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.search-int{
  overflow: hidden;
  background-color: #fff;
  border-radius: 26px;
  width: 835px;
  height: 52px;
  line-height: 52px;
  box-shadow: 0px 0px 1px #cacaca;
}
.search-int input{
  float: left;
  font-size: 14px;
  color: #585555;
  height: 52px;
  line-height: 52px;
  width: 676px;
  border: none;
  outline-style: none;
  padding-left: 18px;
  border-radius: 26px;
  padding-right: 91px;
}
.search-int div{
  float: right;
  height: 40px;
  line-height: 40px;
  margin-top: 6px;
  margin-right: 9px;
  background-color: #587CF7;
  color: #fff;
  width: 82px;
  border-radius: 20px;
  text-align: center;
  font-size: 16px;
  margin-left: -91px;
  cursor: pointer;
}
.EnterpriseIndex-h1{
  width: 860px;
  margin-bottom: 26px;
  border-bottom: 6px solid #5C79F5;
  overflow: hidden;
}
.EnterpriseIndex-change{
  float: left;
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #fff;
  cursor: pointer;
}
.EnterpriseIndex-change div{
  display: inline-block;
  font-weight: bold;
  color: #000;
  font-size: 18px;
}
.EnterpriseIndex-change p{
  display: inline-block;
  color: #5C79F5;
  background-color: #EAF5FA;
  margin-left: 10px;
  margin-top: 13px;
  width: 52px;
  height: 27px;
  border-radius: 8px;
  line-height: 27px;
  font-size: 14px;
}
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  text-align: center;
  margin-bottom: 28px;
}
.personalCore-jobboxs-box-names{
  margin-top: 20px;
  font-size: 18px;
  font-weight: 550;
}
.personalCore-jobboxs-box-titles{
  overflow: hidden;
  margin-top: 12px;
}
.personalCore-jobboxs-box-titles div{
  float: left;
  margin-right: 16px;
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  color: #587CF7;
  background-color: #EDF1FE;
  padding: 2px 16px;
  border-radius: 5px;
}
.personalCore-jobboxs-box-titles div:first-child{
  margin-right: 18px;
  color: #FF6400;
  font-size: 18px;
  background-color: #fff;
  padding: 0;
}
.personalCore-jobboxs-box-résumé{
  float: right;
  margin-right: 83px;
}
.personalCore-jobboxs-box-résumé div:first-child{
  margin-top: 22px;
  text-align: center;
  font-weight: 550;
  margin-bottom: 8px;
  font-size: 18px;
}
.personalCore-jobboxs-box-résumé div:last-child{
  font-size: 18px;
}
.personalCore-jobboxs-bottom{
  position: absolute;
  bottom: 0;
  overflow: hidden;
  width: 100%;
  height: 49px;
  line-height: 49px;
  background-color: #FAFBFE;
}
.personalCore-jobboxs-bottom-titles{
  overflow: hidden;
  float: left;
  margin-left: 20px;
}
.personalCore-jobboxs-bottom-titles div{
  float: left;
  color: #8C8888;
  font-size: 14px;
}
.personalCore-jobboxs-bottom-titles span{
  margin-left: 5px;
  margin-right: 5px;
  font-size: 10px;
  float: right;
  font-weight: 550;
}
.personalCore-jobboxs-bottom-time{
  font-size: 12px;
  color: rgb(117, 117, 117);
  text-align: right;
  float: right;
  margin-right: 20px;
}
.personalCore-jobboxs-bottom-btn{
  margin-right: 257px;
  color: #587CF7;
  font-size: 18px;
  float: right;
}
.personalCore-jobboxs-box-résumé-xiala{
  position: absolute;
  top: 80px;
  right: 21px;
  z-index: 999;
  width: 86px;
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  color: #757575;
  font-size: 12px;
}
.personalCore-jobboxs-box-résumé-xiala div{
  height: 36px;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/enterpriseIndex.vue